export default "__VITE_ASSET__nbZRames__"